module.exports = __webpack_public_path__ + "img/hr-stack-filter-inserter-platform.6df82118.png";